import { Table, TableColumnType, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { AuditEvent } from '@fullstory/proto/fs/services/dx-objects';
import { Timestamp } from '@fullstory/proto/google/protobuf';
import React from 'react';
import { AuditLogToolTip } from '../AuditLogToolTip';
import css from './index.module.scss';

interface AuditLogProps {
  data: AuditEvent[];
}

const columns: TableColumnType<AuditEvent>[] = [
  {
    key: 'update',
    label: intl.formatMessage({ defaultMessage: 'Update', id: 'BWpuKl' }),
    renderCell: event =>
      event.changeValue ? (
        <AuditLogToolTip changeType={event.changeType} changeValue={event.changeValue}>
          <u>
            <Text appearance="bodySmall">{event.changeType}</Text>
          </u>
        </AuditLogToolTip>
      ) : (
        <Text appearance="bodySmall">{event.changeType}</Text>
      ),
  },
  {
    key: 'modifiedBy',
    label: intl.formatMessage({ defaultMessage: 'Modified by', id: 'DJ/vtF' }),
    renderCell: event => (
      <Text appearance="bodySmall" color="secondary" noWrap>
        {event.changeBy}
      </Text>
    ),
  },
  {
    key: 'date',
    label: intl.formatMessage({ defaultMessage: 'Date', id: 'P7PLVj' }),
    renderCell: event => (
      <Text appearance="bodySmall" color="secondary">
        {intl.formatDate(Timestamp.toDate(event.when) || undefined, { dateStyle: 'medium' })}
      </Text>
    ),
  },
];

export function AuditLog({ data }: AuditLogProps) {
  return (
    <Table
      data-component="AuditLog"
      headProps={{
        variant: 'dark',
        rowProps: { cellProps: { fixed: true } },
      }}
      bodyProps={{ rowProps: { cellProps: { className: css.auditLogCell } } }}
      columns={columns}
      rowKeyAccessor="id"
      rows={data}
    />
  );
}
